import {
  RequestCustomerEditAccount,
  ResponseCustomerEditAccount,
} from "./Customer.types";

export const customerInfoIntialValue: ResponseCustomerEditAccount = {
  id: "",
  accountId: "",
  taxId: "",
  legalAccountId: "",
  sapAccountId: "",
  sapCustomerAccountId: "",
  affilation: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  addresses: [
    {
      addressId: "",
      affilation: "",
      name: "",
      street: "",
      postalCode: "",
      city: "",
      province: "",
      country: "",
      registeredtaxId: "",
      customerCertifiedEmail: "",
      customerConsigneeCode: "",
      purchasingCompanyTaxId: "",
      shipmentCompanyTaxId: "",
      sapAccountId: "",
      contacts: {
        contactId: "",
        contactFirstName: "",
        contactLastName: "",
        contactPhone: "",
        contactEmail: "",
        isContactPrimary: "",
      },
      state: "",
      isAddressPrimary: "",
    },
  ],
  country: "",
  customerRegion: "",
  paymentTerms: "",
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
  eTag: "",
  partitionKey: "",
};

export const addresssCustomerInfoIntialValue = {
  id: "",
  accountId: "",
  taxId: "",
  legalAccountId: "",
  affilation: "",
  sapAccountId: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  paymentTerms: "",
  registerAddress: {
    addressId: "",
    affilation: "",
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    isAddressPrimary: "",
    registeredtaxId: "",
    customerCertifiedEmail: "",
    customerConsigneeCode: "",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    sapAccountId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "",
    },
    state: "",
  },
  billingAddress: {
    addressId: "",
    affilation: "",
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    registeredtaxId: "",
    customerCertifiedEmail: "",
    customerConsigneeCode: "",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    sapAccountId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "",
    },
    state: "",
    isAddressPrimary: "",
  },
  shippingAddress: {
    addressId: "",
    affilation: "",
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    customerRegion: "",
    registeredtaxId: "",
    customerCertifiedEmail: "",
    customerConsigneeCode: "",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    sapAccountId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "",
    },
    isAddressPrimary: "",
    state: "",
  },
  fapiaoAddress: {
    addressId: "",
    affilation: "",
    name: "",
    street: "",
    postalCode: "",
    city: "",
    province: "",
    country: "",
    registeredtaxId: "",
    customerCertifiedEmail: "",
    customerConsigneeCode: "",
    purchasingCompanyTaxId: "",
    shipmentCompanyTaxId: "",
    sapAccountId: "",
    contacts: {
      contactId: "",
      contactFirstName: "",
      contactLastName: "",
      contactPhone: "",
      contactEmail: "",
      isContactPrimary: "",
    },
    isAddressPrimary: "",
    state: "",
  },
  country: "",
  customerRegion: "",
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
};

export const newAddressCustomerInfoIntialValue = {
  addressId: "",
  affilation: "",
  street: "",
  postalCode: "",
  city: "",
  province: "",
  country: "",
  name: "",
  registeredtaxId: "",
  customerCertifiedEmail: "",
  customerConsigneeCode: "",
  purchasingCompanyTaxId: "",
  shipmentCompanyTaxId: "",
  sapAccountId: "",
  contacts: {
    contactId: "",
  },
  state: "",
};

export const editAddressCustomerInfoIntialValue = {
  addressId: "",
  affilation: "",
  street: "",
  postalCode: "",
  city: "",
  province: "",
  country: "",
  billingName: "",
  name: "",
  shippingName: "",
  registeredtaxId: "",
  customerCertifiedEmail: "",
  customerConsigneeCode: "",
  purchasingCompanyTaxId: "",
  shipmentCompanyTaxId: "",
  sapAccountId: "",
  contacts: {
    contactId: "",
  },
  state: "",
};

export const customerEditCustomer: RequestCustomerEditAccount = {
  id: "",
  accountId: "",
  taxId: "",
  legalAccountId: "",
  sapAccountId: "",
  sapCustomerAccountId: "",
  affilation: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  addresses: [],
  country: "",
  customerRegion: "",
  purchasingCompanyTaxId: "",
  paymentTerms: "",
  shipmentCompanyTaxId: "",
  partitionKey: "",
  eTag: "",
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
};

export const customerAddressSetup: ResponseCustomerEditAccount = {
  id: "",
  accountId: "",
  taxId: "",
  legalAccountId: "",
  sapAccountId: "",
  sapCustomerAccountId: "",
  affilation: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  addresses: [],
  country: "",
  customerRegion: "",
  paymentTerms: "",
  partitionKey: "",
  eTag: "",
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
};

export const customerDiscountSetup: RequestCustomerEditAccount = {
  id: "",
  accountId: "",
  taxId: "",
  legalAccountId: "",
  sapAccountId: "",
  sapCustomerAccountId: "",
  affilation: "",
  authorizedBuyerFirstName: "",
  authorizedBuyerLastName: "",
  authorizedBuyerTitle: "",
  authorizedBuyerPhone: "",
  authorizedEmailId: "",
  name: "",
  addresses: [],
  country: "",
  customerRegion: "",
  purchasingCompanyTaxId: "",
  paymentTerms: "",
  shipmentCompanyTaxId: "",
  partitionKey: "",
  eTag: "",
  discount: {
    afilliationSelected: "",
    contract: [],
    taxExempt: {
      isTaxExemptChecked: false,
      expirationDate: "",
      taxExemptReason: "",
    },
    customerGroup: {
      governmentDiscountSelected: false,
      employeePricingSelected: false,
      couponCode: [],
    },
    restrictedSkus: "",
  },
};

export const editRegisteredAddressInfoIntialValue = {
  addressId: "",
  affilation: "",
  street: "",
  postalCode: "",
  city: "",
  province: "",
  country: "",
  name: "",
  state: "",
  contacts: {
    contactId: "",
    contactFirstName: "",
    contactLastName: "",
    contactPhone: "",
    contactEmail: "",
    state: "",
    isContactPrimary: "",
  },
};

export const registeredAddressIntialErrorState = {
  registerStreet: "",
  registerPostal: "",
  registerCity: "",
  registerState: "",
  registerCountry: "",
  registerSapAccountId: "",
  registerCustomerCertifiedEmail: "",
  registerCustomerConsigneeCode: "",
  registerTaxId: ""
};

export const registeredContactIntialErrorState = {
  customerAccountId: "",
  contactFirstName: "",
  contactLastName: "",
  contactPhone: "",
  contactEmail: "",
  id: "",
  partitionKey: "",
};

export const affilationOptions = [
  {
    key: "Registered Address",
    text: "Registered Address",
  },
  {
    key: "Billing",
    text: "Billing",
  },
  {
    key: "Shipping",
    text: "Shipping",
  },
];

export const titleOptions = [
  {
    key: "Procurement Manager",
    text: "Procurement Manager",
  },
  {
    key: "Finance Manager",
    text: "Finance Manager",
  },
];

export const paymentTermsOptions = [
  { key: "CreditCard", text: "CreditCard" },
  { key: "N030", text: "Net 30 days" },
  { key: "N045", text: "Net 45 days" },
  { key: "N060", text: "Net 60 days" },
  { key: "N090", text: "Net 90 days" },
  { key: "WirePrepay", text: "WirePrepay" },
];

export const addAdddressAffilationOptions = [
  {
    key: "Billing",
    text: "Billing",
  },
  {
    key: "Shipping",
    text: "Shipping",
  },
];

export const typeAffilationOptions = [
  {
    key: "Business Education/Non-profit",
    text: "Business Education/Non-profit",
  },
  {
    key: "Business Government",
    text: "Business Government",
  },
  {
    key: "Business General",
    text: "Business General",
  },
  {
    key: "Business Military",
    text: "Business Military",
  },
];

export const taxExemptReasonsOptions = [
  {
    key: "Exempt Use",
    text: "Exempt Use",
  },
  {
    key: "Federal Government",
    text: "Federal Government",
  },
  {
    key: "Foreign Diplomat",
    text: "Foreign Diplomat",
  },
  {
    key: "Non Profit",
    text: "Non Profit",
  },
  {
    key: "Resale",
    text: "Resale",
  },
  {
    key: "State Government",
    text: "State Government",
  },
];

export const minumDiscountOptions = [
  {
    key: "10",
    text: "10%",
  },
  {
    key: "11",
    text: "11%",
  },
  {
    key: "12",
    text: "12%",
  },
  {
    key: "13",
    text: "13%",
  },
  {
    key: "14",
    text: "14%",
  },
  {
    key: "15",
    text: "15%",
  },
];

export const businessEducationAffiliation={
  key:"12345",
  text:"Business Education/Non-profit"
};
export const discountReasonsOptions = [
  {
    key: "86120",
    text: "JP -20% off MS Complete - CSS Closed Offer",
  },
  {
    key: "87935",
    text: "JP - Commercial - Accenture Japan Closed Offer",
  },
  {
    key: "87973",
    text: "JPN - Xbox - EPP Promo - Save 10% on Xbox Series S and Series X",
  },
  {
    key: "87982",
    text: "UK - Commercial VISA - closed offer - Save 11% on Surface Pro 9 +TC +Arc Mouse Bundle",
  },
  {
    key: "88147",
    text: "US - SMB - Surface Startups save up to $516 on select Surface Laptop 5 devices & Arc Mouse bundle",
  },
  {
    key: "88600",
    text: "US/CA SMB: Closed Offer to MSFT Customer Base: Surface Startups save up to 20% on select Surface Laptop 5 Devices & Arc Mouse Bundle",
  },
  {
    key: "85476",
    text: "JP - EDU CLOSED OFFER - SURFACE LAPTOP 4",
  },
  {
    key: "85475",
    text: "JP - EDU CLOSED OFFER - SURFACE GO 2/3",
  },
  {
    key: "85478",
    text: "JP - EDU CLOSED OFFER - SURFACE PRO 7/8",
  },
  {
    key: "88893",
    text: "CA - SMB - Closed Offer to MSFT Customer Base: Surface Startups save up to 20% on select Surface Laptop 5 Devices & Arc Mouse Bundle",
  },
  {
    key: "89473",
    text: "AVA_Test_Promo_Ignore",
  },
  {
    key: "89947",
    text: "AU - Surface Consumer - CSS Evergreen - Surface Device + Free Accessory",
  },
  {
    key: "89813",
    text: "US- SMB - BREX Closed Offer, Save 20% on select Pro 9 Devices",
  },
  {
    key: "90156",
    text: "SG - Surface Consumer - CSS Closed Offer - select Pro 9 & Laptop 5",
  },
];

// Region Wise Country List
export const countryOptions = [
  {
    key: "China",
    text: "China",
    region: "China",
  },
  {
    key: "Singapore",
    text: "Singapore",
    region: "APAC",
  },
  {
    key: "Japan",
    text: "Japan",
    region: "Japan",
  },
  {
    key: "Germany",
    text: "Germany",
    region: "EMEA",
  },
  {
    key: "France",
    text: "France",
    region: "EMEA",
  },
  {
    key: "Spain",
    text: "Spain",
    region: "EMEA",
  },
  {
    key: "Italy",
    text: "Italy",
    region: "EMEA",
  },
  {
    key: "Austria",
    text: "Austria",
    region: "EMEA",
  },
  {
    key: "Belgium",
    text: "Belgium",
    region: "EMEA",
  },
  {
    key: "Finland",
    text: "Finland",
    region: "EMEA",
  },
  {
    key: "Denmark",
    text: "Denmark",
    region: "EMEA",
  },
  {
    key: "Ireland",
    text: "Ireland",
    region: "EMEA",
  },
  {
    key: "Luxembourg",
    text: "Luxembourg",
    region: "EMEA",
  },
  {
    key: "Netherlands",
    text: "Netherlands",
    region: "EMEA",
  },
  {
    key: "New Zealand",
    text: "New Zealand",
    region: "APAC",
  },
  {
    key: "Norway",
    text: "Norway",
    region: "EMEA",
  },
  {
    key: "Portugal",
    text: "Portugal",
    region: "EMEA",
  },
  {
    key: "Sweden",
    text: "Sweden",
    region: "EMEA",
  },
  {
    key: "Switzerland",
    text: "Switzerland",
    region: "EMEA",
  },
];

// Country wise state options

const chinaStates = [
  {
    key: "Anhui",
    text: "Anhui",
    country: "China",
  },
  {
    key: "Fujian",
    text: "Fujian",
    country: "China",
  },
  {
    key: "Gansu",
    text: "Gansu",
    country: "China",
  },
  {
    key: "Guangdong",
    text: "Guangdong",
    country: "China",
  },
  {
    key: "Guizhou",
    text: "Guizhou",
    country: "China",
  },
  {
    key: "Hainan",
    text: "Hainan",
    country: "China",
  },
  {
    key: "Heilongjiang",
    text: "Heilongjiang",
    country: "China",
  },
  {
    key: "Hebei",
    text: "Hebei",
    country: "China",
  },
  {
    key: "Henan",
    text: "Henan",
    country: "China",
  },
  {
    key: "Hubei",
    text: "Hubei",
    country: "China",
  },
  {
    key: "Hunan",
    text: "Hunan",
    country: "China",
  },
  {
    key: "Jiangsu",
    text: "Jiangsu",
    country: "China",
  },
  {
    key: "Jiangxi",
    text: "Jiangxi",
    country: "China",
  },
  {
    key: "Jilin",
    text: "Jilin",
    country: "China",
  },
  {
    key: "Liaoning",
    text: "Liaoning",
    country: "China",
  },
  {
    key: "Qinghai",
    text: "Qinghai",
    country: "China",
  },
  {
    key: "Shaanxi",
    text: "Shaanxi",
    country: "China",
  },
  {
    key: "Shandong",
    text: "Shandong",
    country: "China",
  },
  {
    key: "Sichuan",
    text: "Sichuan",
    country: "China",
  },
  {
    key: "Yunnan",
    text: "Yunnan",
    country: "China",
  },
  {
    key: "Zhejiang",
    text: "Zhejiang",
    country: "China",
  },
];

const singaporeStates = [
  {
    key: "Singapore",
    text: "Singapore",
    country: "Singapore",
  },
  {
    key: "Ang Mo Kio",
    text: "Ang Mo Kio",
    country: "Singapore",
  },
  {
    key: "Bedok",
    text: "Bedok",
    country: "Singapore",
  },
  {
    key: "Bishan",
    text: "Bishan",
    country: "Singapore",
  },
  {
    key: "Bukit Batok",
    text: "Bukit Batok",
    country: "Singapore",
  },
  {
    key: "Bukit Merah",
    text: "Bukit Merah",
    country: "Singapore",
  },
  {
    key: "Bukit Panjang",
    text: "Bukit Panjang",
    country: "Singapore",
  },
  {
    key: "Bukit Timah",
    text: "Bukit Timah",
    country: "Singapore",
  },
  {
    key: "Central Area",
    text: "Central Area",
    country: "Singapore",
  },
  {
    key: "Choa Chu Kang",
    text: "Choa Chu Kang",
    country: "Singapore",
  },
  {
    key: "Clementi",
    text: "Clementi",
    country: "Singapore",
  },
  {
    key: "Geylang",
    text: "Geylang",
    country: "Singapore",
  },
  {
    key: "Hougang",
    text: "Hougang",
    country: "Singapore",
  },
  {
    key: "Jurong East",
    text: "Jurong East",
    country: "Singapore",
  },
  {
    key: "Jurong West",
    text: "Jurong West",
    country: "Singapore",
  },
  {
    key: "Kallang/Whampoa",
    text: "Kallang/Whampoa",
    country: "Singapore",
  },
  {
    key: "Lim Chu Kang",
    text: "Lim Chu Kang",
    country: "Singapore",
  },
  {
    key: "Marine Parade",
    text: "Marine Parade",
    country: "Singapore",
  },
  {
    key: "Pasir Ris",
    text: "Pasir Ris",
    country: "Singapore",
  },
  {
    key: "Punggol",
    text: "Punggol",
    country: "Singapore",
  },
  {
    key: "Queenstown",
    text: "Queenstown",
    country: "Singapore",
  },
  {
    key: "Sembawang",
    text: "Sembawang",
    country: "Singapore",
  },
  {
    key: "Sengkang",
    text: "Sengkang",
    country: "Singapore",
  },
  {
    key: "Serangoon",
    text: "Serangoon",
    country: "Singapore",
  },
  {
    key: "Tampines",
    text: "Tampines",
    country: "Singapore",
  },
  {
    key: "Toa Payoh",
    text: "Toa Payoh",
    country: "Singapore",
  },
  {
    key: "Woodlands",
    text: "Woodlands",
    country: "Singapore",
  },
  {
    key: "Yishun",
    text: "Yishun",
    country: "Singapore",
  },
];

const japanStates = [
  {
    key: "Hokkaido",
    text: "Hokkaido",
    country: "Japan",
  },
  {
    key: "Aomori",
    text: "Aomori",
    country: "Japan",
  },
  {
    key: "Iwate",
    text: "Iwate",
    country: "Japan",
  },
  {
    key: "Miyagi",
    text: "Miyagi",
    country: "Japan",
  },
  {
    key: "Akita",
    text: "Akita",
    country: "Japan",
  },
  {
    key: "Yamagata",
    text: "Yamagata",
    country: "Japan",
  },
  {
    key: "Fukushima",
    text: "Fukushima",
    country: "Japan",
  },
  {
    key: "Ibaraki",
    text: "Ibaraki",
    country: "Japan",
  },
  {
    key: "Tochigi",
    text: "Tochigi",
    country: "Japan",
  },
  {
    key: "Gunma",
    text: "Gunma",
    country: "Japan",
  },
  {
    key: "Saitama",
    text: "Saitama",
    country: "Japan",
  },
  {
    key: "Chiba",
    text: "Chiba",
    country: "Japan",
  },
  {
    key: "Tokyo",
    text: "Tokyo",
    country: "Japan",
  },
  {
    key: "Kanagawa",
    text: "Kanagawa",
    country: "Japan",
  },
  {
    key: "Niigata",
    text: "Niigata",
    country: "Japan",
  },
  {
    key: "Toyama",
    text: "Toyama",
    country: "Japan",
  },
  {
    key: "Ishikawa",
    text: "Ishikawa",
    country: "Japan",
  },
  {
    key: "Fukui",
    text: "Fukui",
    country: "Japan",
  },
  {
    key: "Yamanashi",
    text: "Yamanashi",
    country: "Japan",
  },
  {
    key: "Nagano",
    text: "Nagano",
    country: "Japan",
  },
  {
    key: "Gifu",
    text: "Gifu",
    country: "Japan",
  },
  {
    key: "Shizuoka",
    text: "Shizuoka",
    country: "Japan",
  },
  {
    key: "Aichi",
    text: "Aichi",
    country: "Japan",
  },
  {
    key: "Mie",
    text: "Mie",
    country: "Japan",
  },
  {
    key: "Shiga",
    text: "Shiga",
    country: "Japan",
  },
  {
    key: "Kyoto",
    text: "Kyoto",
    country: "Japan",
  },
  {
    key: "Osaka",
    text: "Osaka",
    country: "Japan",
  },
  {
    key: "Hyogo",
    text: "Hyogo",
    country: "Japan",
  },
  {
    key: "Nara",
    text: "Nara",
    country: "Japan",
  },
  {
    key: "Wakayama",
    text: "Wakayama",
    country: "Japan",
  },
  {
    key: "Tottori",
    text: "Tottori",
    country: "Japan",
  },
  {
    key: "Shimane",
    text: "Shimane",
    country: "Japan",
  },
  {
    key: "Okayama",
    text: "Okayama",
    country: "Japan",
  },
  {
    key: "Hiroshima",
    text: "Hiroshima",
    country: "Japan",
  },
  {
    key: "Yamaguchi",
    text: "Yamaguchi",
    country: "Japan",
  },
  {
    key: "Tokushima",
    text: "Tokushima",
    country: "Japan",
  },
  {
    key: "Kagawa",
    text: "Kagawa",
    country: "Japan",
  },
  {
    key: "Ehime",
    text: "Ehime",
    country: "Japan",
  },
  {
    key: "Kochi",
    text: "Kochi",
    country: "Japan",
  },
  {
    key: "Fukuoka",
    text: "Fukuoka",
    country: "Japan",
  },
  {
    key: "Saga",
    text: "Saga",
    country: "Japan",
  },
  {
    key: "Nagasaki",
    text: "Nagasaki",
    country: "Japan",
  },
  {
    key: "Kumamoto",
    text: "Kumamoto",
    country: "Japan",
  },
  {
    key: "Oita",
    text: "Oita",
    country: "Japan",
  },
  {
    key: "Miyazaki",
    text: "Miyazaki",
    country: "Japan",
  },
  {
    key: "Kagoshima",
    text: "Kagoshima",
    country: "Japan",
  },
  {
    key: "Okinawa",
    text: "Okinawa",
    country: "Japan",
  },
];

const germanyStates = [
  {
    key: "Baden-Württemberg",
    text: "Baden-Württemberg",
    country: "Germany",
  },
  {
    key: "Bayern",
    text: "Bayern",
    country: "Germany",
  },
  {
    key: "Berlin",
    text: "Berlin",
    country: "Germany",
  },
  {
    key: "Brandenburg",
    text: "Brandenburg",
    country: "Germany",
  },
  {
    key: "Bremen",
    text: "Bremen",
    country: "Germany",
  },
  {
    key: "Hamburg",
    text: "Hamburg",
    country: "Germany",
  },
  {
    key: "Hessen",
    text: "Hessen",
    country: "Germany",
  },
  {
    key: "Mecklenburg-Vorpommern",
    text: "Mecklenburg-Vorpommern",
    country: "Germany",
  },
  {
    key: "Niedersachsen",
    text: "Niedersachsen",
    country: "Germany",
  },
  {
    key: "Nordrhein-Westfalen",
    text: "Nordrhein-Westfalen",
    country: "Germany",
  },
  {
    key: "Rheinland-Pfalz",
    text: "Rheinland-Pfalz",
    country: "Germany",
  },
  {
    key: "Saarland",
    text: "Saarland",
    country: "Germany",
  },
  {
    key: "Sachsen",
    text: "Sachsen",
    country: "Germany",
  },
  {
    key: "Sachsen-Anhalt",
    text: "Sachsen-Anhalt",
    country: "Germany",
  },
  {
    key: "Schleswig-Holstein",
    text: "Schleswig-Holstein",
    country: "Germany",
  },
  {
    key: "Thüringen",
    text: "Thüringen",
    country: "Germany",
  },
];

const franceStates = [
  {
    key: "Auvergne-Rhône-Alpes",
    text: "Auvergne-Rhône-Alpes",
    country: "France",
  },
  {
    key: "Bourgogne-Franche-Comté",
    text: "Bourgogne-Franche-Comté",
    country: "France",
  },
  {
    key: "Brittany",
    text: "Brittany",
    country: "France",
  },
  {
    key: "Centre-Val de Loire",
    text: "Centre-Val de Loire",
    country: "France",
  },
  {
    key: "Corsica",
    text: "Corsica",
    country: "France",
  },
  {
    key: "Grand Est",
    text: "Grand Est",
    country: "France",
  },
  {
    key: "Hauts-de-France",
    text: "Hauts-de-France",
    country: "France",
  },
  {
    key: "Île-de-France",
    text: "Île-de-France",
    country: "France",
  },
  {
    key: "Normandy",
    text: "Normandy",
    country: "France",
  },
  {
    key: "Nouvelle-Aquitaine",
    text: "Nouvelle-Aquitaine",
    country: "France",
  },
  {
    key: "Occitanie",
    text: "Occitanie",
    country: "France",
  },
  {
    key: "Pays de la Loire",
    text: "Pays de la Loire",
    country: "France",
  },
  {
    key: "Provence-Alpes-Côte d'Azur",
    text: "Provence-Alpes-Côte d'Azur",
    country: "France",
  },
];

const spainStates = [
  {
    key: "Madrid",
    text: "Madrid",
    country: "Spain",
  },
  {
    key: "Barcelona",
    text: "Barcelona",
    country: "Spain",
  },
  {
    key: "Valencia",
    text: "Valencia",
    country: "Spain",
  },
  {
    key: "Sevilla",
    text: "Sevilla",
    country: "Spain",
  },
  {
    key: "Alicante",
    text: "Alicante",
    country: "Spain",
  },
  {
    key: "Málaga",
    text: "Málaga",
    country: "Spain",
  },
  {
    key: "Murcia",
    text: "Murcia",
    country: "Spain",
  },
  {
    key: "Cádiz",
    text: "Cádiz",
    country: "Spain",
  },
  {
    key: "Baleares",
    text: "Baleares",
    country: "Spain",
  },
  {
    key: "Vizcaya / Bizkaia",
    text: "Vizcaya / Bizkaia",
    country: "Spain",
  },
  {
    key: "Las Palmas",
    text: "Las Palmas",
    country: "Spain",
  },
  {
    key: "La Coruña / A Coruña / Coruña",
    text: "La Coruña / A Coruña / Coruña",
    country: "Spain",
  },
  {
    key: "Santa Cruz de Tenerife",
    text: "Santa Cruz de Tenerife",
    country: "Spain",
  },
  {
    key: "Asturias",
    text: "Asturias",
    country: "Spain",
  },
  {
    key: "Zaragoza",
    text: "Zaragoza",
    country: "Spain",
  },
  {
    key: "Pontevedra",
    text: "Pontevedra",
    country: "Spain",
  },
  {
    key: "Granada",
    text: "Granada",
    country: "Spain",
  },
  {
    key: "Tarragona",
    text: "Tarragona",
    country: "Spain",
  },
  {
    key: "Gerona / Girona",
    text: "Gerona / Girona",
    country: "Spain",
  },
  {
    key: "Córdoba",
    text: "Córdoba",
    country: "Spain",
  },
  {
    key: "Almería",
    text: "Almería",
    country: "Spain",
  },
  {
    key: "Toledo",
    text: "Toledo",
    country: "Spain",
  },
  {
    key: "Guipúzcoa / Gipuzkoa",
    text: "Guipúzcoa / Gipuzkoa",
    country: "Spain",
  },
  {
    key: "Navarra",
    text: "Navarra",
    country: "Spain",
  },
  {
    key: "Badajoz",
    text: "Badajoz",
    country: "Spain",
  },
  {
    key: "Jaén",
    text: "Jaén",
    country: "Spain",
  },
  {
    key: "Castellón",
    text: "Castellón",
    country: "Spain",
  },
  {
    key: "Cantabria",
    text: "Cantabria",
    country: "Spain",
  },
  {
    key: "Huelva",
    text: "Huelva",
    country: "Spain",
  },
  {
    key: "Valladolid",
    text: "Valladolid",
    country: "Spain",
  },
  {
    key: "Ciudad Real",
    text: "Ciudad Real",
    country: "Spain",
  },
  {
    key: "León",
    text: "León",
    country: "Spain",
  },
  {
    key: "Lérida / Lleida",
    text: "Lérida / Lleida",
    country: "Spain",
  },
  {
    key: "Cáceres",
    text: "Cáceres",
    country: "Spain",
  },
  {
    key: "Albacete",
    text: "Albacete",
    country: "Spain",
  },
  {
    key: "Burgos",
    text: "Burgos",
    country: "Spain",
  },
  {
    key: "Álava / Araba",
    text: "Álava / Araba",
    country: "Spain",
  },
  {
    key: "Salamanca",
    text: "Salamanca",
    country: "Spain",
  },
  {
    key: "Lugo",
    text: "Lugo",
    country: "Spain",
  },
  {
    key: "La Rioja",
    text: "La Rioja",
    country: "Spain",
  },
  {
    key: "Orense / Ourense",
    text: "Orense / Ourense",
    country: "Spain",
  },
  {
    key: "Guadalajara",
    text: "Guadalajara",
    country: "Spain",
  },
  {
    key: "Huesca",
    text: "Huesca",
    country: "Spain",
  },
  {
    key: "Cuenca",
    text: "Cuenca",
    country: "Spain",
  },
  {
    key: "Zamora",
    text: "Zamora",
    country: "Spain",
  },
  {
    key: "Ávila",
    text: "Ávila",
    country: "Spain",
  },
  {
    key: "Palencia",
    text: "Palencia",
    country: "Spain",
  },
  {
    key: "Segovia",
    text: "Segovia",
    country: "Spain",
  },
  {
    key: "Teruel",
    text: "Teruel",
    country: "Spain",
  },
  {
    key: "Soria",
    text: "Soria",
    country: "Spain",
  },
  {
    key: "Melilla",
    text: "Melilla",
    country: "Spain",
  },
  {
    key: "Ceuta",
    text: "Ceuta",
    country: "Spain",
  },
];

const italyStates = [
  {
    key: "Agrigento",
    text: "Agrigento",
    country: "Italy",
  },
  {
    key: "Alessandria",
    text: "Alessandria",
    country: "Italy",
  },
  {
    key: "Ancona",
    text: "Ancona",
    country: "Italy",
  },
  {
    key: "Aosta",
    text: "Aosta",
    country: "Italy",
  },
  {
    key: "Arezzo",
    text: "Arezzo",
    country: "Italy",
  },
  {
    key: "Ascoli Piceno",
    text: "Ascoli Piceno",
    country: "Italy",
  },
  {
    key: "Asti",
    text: "Asti",
    country: "Italy",
  },
  {
    key: "Avellino",
    text: "Avellino",
    country: "Italy",
  },
  {
    key: "Bari",
    text: "Bari",
    country: "Italy",
  },
  {
    key: "Barletta-Andria-Trani",
    text: "Barletta-Andria-Trani",
    country: "Italy",
  },
  {
    key: "Belluno",
    text: "Belluno",
    country: "Italy",
  },
  {
    key: "Benevento",
    text: "Benevento",
    country: "Italy",
  },
  {
    key: "Bergamo",
    text: "Bergamo",
    country: "Italy",
  },
  {
    key: "Biella",
    text: "Biella",
    country: "Italy",
  },
  {
    key: "Bologna",
    text: "Bologna",
    country: "Italy",
  },
  {
    key: "Bolzano",
    text: "Bolzano",
    country: "Italy",
  },
  {
    key: "Brescia",
    text: "Brescia",
    country: "Italy",
  },
  {
    key: "Brindisi",
    text: "Brindisi",
    country: "Italy",
  },
  {
    key: "Cagliari",
    text: "Cagliari",
    country: "Italy",
  },
  {
    key: "Caltanissetta",
    text: "Caltanissetta",
    country: "Italy",
  },
  {
    key: "Campobasso",
    text: "Campobasso",
    country: "Italy",
  },
  {
    key: "Carbonia-Iglesias",
    text: "Carbonia-Iglesias",
    country: "Italy",
  },
  {
    key: "Caserta",
    text: "Caserta",
    country: "Italy",
  },
  {
    key: "Catania",
    text: "Catania",
    country: "Italy",
  },
  {
    key: "Catanzaro",
    text: "Catanzaro",
    country: "Italy",
  },
  {
    key: "Chieti",
    text: "Chieti",
    country: "Italy",
  },
  {
    key: "Como",
    text: "Como",
    country: "Italy",
  },
  {
    key: "Cosenza",
    text: "Cosenza",
    country: "Italy",
  },
  {
    key: "Cremona",
    text: "Cremona",
    country: "Italy",
  },
  {
    key: "Crotone",
    text: "Crotone",
    country: "Italy",
  },
  {
    key: "Cuneo",
    text: "Cuneo",
    country: "Italy",
  },
  {
    key: "Enna",
    text: "Enna",
    country: "Italy",
  },
  {
    key: "Fermo",
    text: "Fermo",
    country: "Italy",
  },
  {
    key: "Ferrara",
    text: "Ferrara",
    country: "Italy",
  },
  {
    key: "Florence",
    text: "Florence",
    country: "Italy",
  },
  {
    key: "Foggia",
    text: "Foggia",
    country: "Italy",
  },
  {
    key: "Forlì-Cesena",
    text: "Forlì-Cesena",
    country: "Italy",
  },
  {
    key: "Frosinone",
    text: "Frosinone",
    country: "Italy",
  },
  {
    key: "Genoa",
    text: "Genoa",
    country: "Italy",
  },
  {
    key: "Gorizia",
    text: "Gorizia",
    country: "Italy",
  },
  {
    key: "Grosseto",
    text: "Grosseto",
    country: "Italy",
  },
  {
    key: "Imperia",
    text: "Imperia",
    country: "Italy",
  },
  {
    key: "Isernia",
    text: "Isernia",
    country: "Italy",
  },
  {
    key: "La Spezia",
    text: "La Spezia",
    country: "Italy",
  },
  {
    key: "L'Aquila",
    text: "L'Aquila",
    country: "Italy",
  },
  {
    key: "Latina",
    text: "Latina",
    country: "Italy",
  },
  {
    key: "Lecce",
    text: "Lecce",
    country: "Italy",
  },
  {
    key: "Lecco",
    text: "Lecco",
    country: "Italy",
  },
  {
    key: "Livorno",
    text: "Livorno",
    country: "Italy",
  },
  {
    key: "Lodi",
    text: "Lodi",
    country: "Italy",
  },
  {
    key: "Lucca",
    text: "Lucca",
    country: "Italy",
  },
  {
    key: "Macerata",
    text: "Macerata",
    country: "Italy",
  },
  {
    key: "Mantova",
    text: "Mantova",
    country: "Italy",
  },
  {
    key: "Massa-Carrara",
    text: "Massa-Carrara",
    country: "Italy",
  },
  {
    key: "Matera",
    text: "Matera",
    country: "Italy",
  },
  {
    key: "Medio Campidano",
    text: "Medio Campidano",
    country: "Italy",
  },
  {
    key: "Messina",
    text: "Messina",
    country: "Italy",
  },
  {
    key: "Milan",
    text: "Milan",
    country: "Italy",
  },
  {
    key: "Modena",
    text: "Modena",
    country: "Italy",
  },
  {
    key: "Monza e Brianza",
    text: "Monza e Brianza",
    country: "Italy",
  },
  {
    key: "Naples",
    text: "Naples",
    country: "Italy",
  },
  {
    key: "Novara",
    text: "Novara",
    country: "Italy",
  },
  {
    key: "Nuoro",
    text: "Nuoro",
    country: "Italy",
  },
  {
    key: "Ogliastra",
    text: "Ogliastra",
    country: "Italy",
  },
  {
    key: "Olbia-Tempio",
    text: "Olbia-Tempio",
    country: "Italy",
  },
  {
    key: "Oristano",
    text: "Oristano",
    country: "Italy",
  },
  {
    key: "Padova",
    text: "Padova",
    country: "Italy",
  },
  {
    key: "Palermo",
    text: "Palermo",
    country: "Italy",
  },
  {
    key: "Parma",
    text: "Parma",
    country: "Italy",
  },
  {
    key: "Pavia",
    text: "Pavia",
    country: "Italy",
  },
  {
    key: "Perugia",
    text: "Perugia",
    country: "Italy",
  },
  {
    key: "Pesaro e Urbino",
    text: "Pesaro e Urbino",
    country: "Italy",
  },
  {
    key: "Pescara",
    text: "Pescara",
    country: "Italy",
  },
  {
    key: "Piacenza",
    text: "Piacenza",
    country: "Italy",
  },
  {
    key: "Pisa",
    text: "Pisa",
    country: "Italy",
  },
  {
    key: "Pistoia",
    text: "Pistoia",
    country: "Italy",
  },
  {
    key: "Pordenone",
    text: "Pordenone",
    country: "Italy",
  },
  {
    key: "Potenza",
    text: "Potenza",
    country: "Italy",
  },
  {
    key: "Prato",
    text: "Prato",
    country: "Italy",
  },
  {
    key: "Ragusa",
    text: "Ragusa",
    country: "Italy",
  },
  {
    key: "Ravenna",
    text: "Ravenna",
    country: "Italy",
  },
  {
    key: "Reggio Calabria",
    text: "Reggio Calabria",
    country: "Italy",
  },
  {
    key: "Reggio Emilia",
    text: "Reggio Emilia",
    country: "Italy",
  },
  {
    key: "Rieti",
    text: "Rieti",
    country: "Italy",
  },
  {
    key: "Rimini",
    text: "Rimini",
    country: "Italy",
  },
  {
    key: "Rome",
    text: "Rome",
    country: "Italy",
  },
  {
    key: "Rovigo",
    text: "Rovigo",
    country: "Italy",
  },
  {
    key: "Salerno",
    text: "Salerno",
    country: "Italy",
  },
  {
    key: "Sassari",
    text: "Sassari",
    country: "Italy",
  },
  {
    key: "Savona",
    text: "Savona",
    country: "Italy",
  },
  {
    key: "Siena",
    text: "Siena",
    country: "Italy",
  },
  {
    key: "Siracusa",
    text: "Siracusa",
    country: "Italy",
  },
  {
    key: "Sondrio",
    text: "Sondrio",
    country: "Italy",
  },
  {
    key: "Taranto",
    text: "Taranto",
    country: "Italy",
  },
  {
    key: "Teramo",
    text: "Teramo",
    country: "Italy",
  },
  {
    key: "Terni",
    text: "Terni",
    country: "Italy",
  },
  {
    key: "Trapani",
    text: "Trapani",
    country: "Italy",
  },
  {
    key: "Trento",
    text: "Trento",
    country: "Italy",
  },
  {
    key: "Treviso",
    text: "Treviso",
    country: "Italy",
  },
  {
    key: "Trieste",
    text: "Trieste",
    country: "Italy",
  },
  {
    key: "Turin",
    text: "Turin",
    country: "Italy",
  },
  {
    key: "Udine",
    text: "Udine",
    country: "Italy",
  },
  {
    key: "Varese",
    text: "Varese",
    country: "Italy",
  },
  {
    key: "Venice",
    text: "Venice",
    country: "Italy",
  },
  {
    key: "Verbano-Cusio-Ossola",
    text: "Verbano-Cusio-Ossola",
    country: "Italy",
  },
  {
    key: "Vercelli",
    text: "Vercelli",
    country: "Italy",
  },
  {
    key: "Verona",
    text: "Verona",
    country: "Italy",
  },
  {
    key: "Vibo Valentia",
    text: "Vibo Valentia",
    country: "Italy",
  },
  {
    key: "Vicenza",
    text: "Vicenza",
    country: "Italy",
  },
  {
    key: "Viterbo",
    text: "Viterbo",
    country: "Italy",
  },
];

const austriaStates = [
  {
    key: "Burgenland",
    text: "Burgenland",
    country: "Austria",
  },
  {
    key: "Carinthia",
    text: "Carinthia",
    country: "Austria",
  },
  {
    key: "Lower Austria",
    text: "Lower Austria",
    country: "Austria",
  },
  {
    key: "Upper Austria",
    text: "Upper Austria",
    country: "Austria",
  },
  {
    key: "Salzburg",
    text: "Salzburg",
    country: "Austria",
  },
  {
    key: "Styria",
    text: "Styria",
    country: "Austria",
  },
  {
    key: "Tyrol",
    text: "Tyrol",
    country: "Austria",
  },
  {
    key: "Vorarlberg",
    text: "Vorarlberg",
    country: "Austria",
  },
  {
    key: "Vienna",
    text: "Vienna",
    country: "Austria",
  },
];

const belgiumStates = [
  {
    key: "Antwerpen",
    text: "Antwerpen",
    country: "Belgium",
  },
  {
    key: "Limburg",
    text: "Limburg",
    country: "Belgium",
  },
  {
    key: "Oost-Vlaanderen",
    text: "Oost-Vlaanderen",
    country: "Belgium",
  },
  {
    key: "Vlaams-Brabant",
    text: "Vlaams-Brabant",
    country: "Belgium",
  },
  {
    key: "West-Vlaanderen",
    text: "West-Vlaanderen",
    country: "Belgium",
  },
  {
    key: "Henegouwen (Hainaut)",
    text: "Henegouwen (Hainaut)",
    country: "Belgium",
  },
  {
    key: "Luik (Liège)",
    text: "Luik (Liège)",
    country: "Belgium",
  },
  {
    key: "Luxemburg",
    text: "Luxemburg",
    country: "Belgium",
  },
  {
    key: "Namen (Namur)",
    text: "Namen (Namur)",
    country: "Belgium",
  },
  {
    key: "Waals-Brabant (Brabant wallon)",
    text: "Waals-Brabant (Brabant wallon)",
    country: "Belgium",
  },
  {
    key: "Brussels Hoofdstedelijk Gewest",
    text: "Brussels Hoofdstedelijk Gewest",
    country: "Belgium",
  },
];

const finlandStates = [
  {
    key: "Åland Islands",
    text: "Åland Islands",
    country: "Finland",
  },
  {
    key: "Central Finland",
    text: "Central Finland",
    country: "Finland",
  },
  {
    key: "Central Ostrobothnia",
    text: "Central Ostrobothnia",
    country: "Finland",
  },
  {
    key: "Eastern Finland",
    text: "Eastern Finland",
    country: "Finland",
  },
  {
    key: "Kainuu",
    text: "Kainuu",
    country: "Finland",
  },
  {
    key: "Kymenlaakso",
    text: "Kymenlaakso",
    country: "Finland",
  },
  {
    key: "Lapland",
    text: "Lapland",
    country: "Finland",
  },
  {
    key: "North Karelia",
    text: "North Karelia",
    country: "Finland",
  },
  {
    key: "Northern Ostrobothnia",
    text: "Northern Ostrobothnia",
    country: "Finland",
  },
  {
    key: "Northern Savonia",
    text: "Northern Savonia",
    country: "Finland",
  },
  {
    key: "Ostrobothnia",
    text: "Ostrobothnia",
    country: "Finland",
  },
  {
    key: "Pirkanmaa",
    text: "Pirkanmaa",
    country: "Finland",
  },
  {
    key: "Satakunta",
    text: "Satakunta",
    country: "Finland",
  },
  {
    key: "South Karelia",
    text: "South Karelia",
    country: "Finland",
  },
  {
    key: "Southern Ostrobothnia",
    text: "Southern Ostrobothnia",
    country: "Finland",
  },
  {
    key: "Southern Savonia",
    text: "Southern Savonia",
    country: "Finland",
  },
  {
    key: "Uusimaa",
    text: "Uusimaa",
    country: "Finland",
  },
  {
    key: "Varsinais-Suomi",
    text: "Varsinais-Suomi",
    country: "Finland",
  },
  {
    key: "Päijänne Tavastia",
    text: "Päijänne Tavastia",
    country: "Finland",
  },
  {
    key: "Tavastia Proper",
    text: "Tavastia Proper",
    country: "Finland",
  },
];

const denmarkStates = [
  {
    key: "Bornholm",
    text: "Bornholm",
    country: "Denmark",
  },
  {
    key: "Copenhagen City",
    text: "Copenhagen City",
    country: "Denmark",
  },
  {
    key: "Copenhagen Surroundings",
    text: "Copenhagen Surroundings",
    country: "Denmark",
  },
  {
    key: "East Jutland",
    text: "East Jutland",
    country: "Denmark",
  },
  {
    key: "North Jutland",
    text: "North Jutland",
    country: "Denmark",
  },
  {
    key: "South Jutland",
    text: "South Jutland",
    country: "Denmark",
  },
  {
    key: "West Jutland",
    text: "West Jutland",
    country: "Denmark",
  },
  {
    key: "East Zealand",
    text: "East Zealand",
    country: "Denmark",
  },
  {
    key: "North Zealand",
    text: "North Zealand",
    country: "Denmark",
  },
  {
    key: "Funen",
    text: "Funen",
    country: "Denmark",
  },
  {
    key: "Vest-og Sydsjælland",
    text: "Vest-og Sydsjælland",
    country: "Denmark",
  },
];

const irelandStates = [
  {
    key: "Carlow",
    text: "Carlow",
    country: "Ireland",
  },
  {
    key: "Cavan",
    text: "Cavan",
    country: "Ireland",
  },
  {
    key: "Clare",
    text: "Clare",
    country: "Ireland",
  },
  {
    key: "Cork",
    text: "Cork",
    country: "Ireland",
  },
  {
    key: "Donegal",
    text: "Donegal",
    country: "Ireland",
  },
  {
    key: "Dublin",
    text: "Dublin",
    country: "Ireland",
  },
  {
    key: "Galway",
    text: "Galway",
    country: "Ireland",
  },
  {
    key: "Kerry",
    text: "Kerry",
    country: "Ireland",
  },
  {
    key: "Kildare",
    text: "Kildare",
    country: "Ireland",
  },
  {
    key: "Kilkenny",
    text: "Kilkenny",
    country: "Ireland",
  },
  {
    key: "Laois",
    text: "Laois",
    country: "Ireland",
  },
  {
    key: "Leitrim",
    text: "Leitrim",
    country: "Ireland",
  },
  {
    key: "Limerick",
    text: "Limerick",
    country: "Ireland",
  },
  {
    key: "Longford",
    text: "Longford",
    country: "Ireland",
  },
  {
    key: "Louth",
    text: "Louth",
    country: "Ireland",
  },
  {
    key: "Mayo",
    text: "Mayo",
    country: "Ireland",
  },
  {
    key: "Meath",
    text: "Meath",
    country: "Ireland",
  },
  {
    key: "Monaghan",
    text: "Monaghan",
    country: "Ireland",
  },
  {
    key: "Offaly",
    text: "Offaly",
    country: "Ireland",
  },
  {
    key: "Roscommon",
    text: "Roscommon",
    country: "Ireland",
  },
  {
    key: "Sligo",
    text: "Sligo",
    country: "Ireland",
  },
  {
    key: "Tipperary",
    text: "Tipperary",
    country: "Ireland",
  },
  {
    key: "Waterford",
    text: "Waterford",
    country: "Ireland",
  },
  {
    key: "Westmeath",
    text: "Westmeath",
    country: "Ireland",
  },
  {
    key: "Wexford",
    text: "Wexford",
    country: "Ireland",
  },
  {
    key: "Wicklow",
    text: "Wicklow",
    country: "Ireland",
  },
];

const luxembourgStates = [
  {
    key: "Diekirch",
    text: "Diekirch",
    country: "Luxembourg",
  },
  {
    key: "Grevenmacher",
    text: "Grevenmacher",
    country: "Luxembourg",
  },
  {
    key: "Luxembourg",
    text: "Luxembourg",
    country: "Luxembourg",
  },
];

const netherlandStates = [
  {
    key: "Drenthe",
    text: "Drenthe",
    country: "Netherlands",
  },
  {
    key: "Flevoland",
    text: "Flevoland",
    country: "Netherlands",
  },
  {
    key: "Friesland",
    text: "Friesland",
    country: "Netherlands",
  },
  {
    key: "Gelderland",
    text: "Gelderland",
    country: "Netherlands",
  },
  {
    key: "Groningen",
    text: "Groningen",
    country: "Netherlands",
  },
  {
    key: "Limburg",
    text: "Limburg",
    country: "Netherlands",
  },
  {
    key: "Noord Brabant",
    text: "Noord Brabant",
    country: "Netherlands",
  },
  {
    key: "Noord Holland",
    text: "Noord Holland",
    country: "Netherlands",
  },
  {
    key: "Overijssel",
    text: "Overijssel",
    country: "Netherlands",
  },
  {
    key: "Zuid Holland",
    text: "Zuid Holland",
    country: "Netherlands",
  },
  {
    key: "Utrecht",
    text: "Utrecht",
    country: "Netherlands",
  },
  {
    key: "Zeeland",
    text: "Zeeland",
    country: "Netherlands",
  },
];

const newZealandStates = [
  {
    key: "Northland",
    text: "Northland",
    country: "New Zealand",
  },
  {
    key: "Auckland",
    text: "Auckland",
    country: "New Zealand",
  },
  {
    key: "Waikato",
    text: "Waikato",
    country: "New Zealand",
  },
  {
    key: "Bay of Plenty",
    text: "Bay of Plenty",
    country: "New Zealand",
  },
  {
    key: "Gisborne",
    text: "Gisborne",
    country: "New Zealand",
  },
  {
    key: "Hawke's Bay",
    text: "Hawke's Bay",
    country: "New Zealand",
  },
  {
    key: "Taranaki",
    text: "Taranaki",
    country: "New Zealand",
  },
  {
    key: "Manawatu-Wanganui",
    text: "Manawatu-Wanganui",
    country: "New Zealand",
  },
  {
    key: "Wellington",
    text: "Wellington",
    country: "New Zealand",
  },
  {
    key: "Tasman",
    text: "Tasman",
    country: "New Zealand",
  },
  {
    key: "Nelson",
    text: "Nelson",
    country: "New Zealand",
  },
  {
    key: "Marlborough",
    text: "Marlborough",
    country: "New Zealand",
  },
  {
    key: "West Coast",
    text: "West Coast",
    country: "New Zealand",
  },
  {
    key: "Canterbury",
    text: "Canterbury",
    country: "New Zealand",
  },
  {
    key: "Otago",
    text: "Otago",
    country: "New Zealand",
  },
  {
    key: "Southland",
    text: "Southland",
    country: "New Zealand",
  },
];

const norwayStates = [
  {
    key: "Agder",
    text: "Agder",
    country: "Norway",
  },
  {
    key: "Innlandet",
    text: "Innlandet",
    country: "Norway",
  },
  {
    key: "Møre og Romsdal",
    text: "Møre og Romsdal",
    country: "Norway",
  },
  {
    key: "Nordland",
    text: "Nordland",
    country: "Norway",
  },
  {
    key: "Oslo",
    text: "Oslo",
    country: "Norway",
  },
  {
    key: "Rogaland",
    text: "Rogaland",
    country: "Norway",
  },
  {
    key: "Troms og Finnmark",
    text: "Troms og Finnmark",
    country: "Norway",
  },
  {
    key: "Trøndelag",
    text: "Trøndelag",
    country: "Norway",
  },
  {
    key: "Vestfold og Telemark",
    text: "Vestfold og Telemark",
    country: "Norway",
  },
  {
    key: "Vestland",
    text: "Vestland",
    country: "Norway",
  },
  {
    key: "Viken",
    text: "Viken",
    country: "Norway",
  },
];

const portugalStates = [
  {
    key: "Aveiro",
    text: "Aveiro",
    country: "Portugal",
  },
  {
    key: "Beja",
    text: "Beja",
    country: "Portugal",
  },
  {
    key: "Braga",
    text: "Braga",
    country: "Portugal",
  },
  {
    key: "Bragança",
    text: "Bragança",
    country: "Portugal",
  },
  {
    key: "Castelo Branco",
    text: "Castelo Branco",
    country: "Portugal",
  },
  {
    key: "Coimbra",
    text: "Coimbra",
    country: "Portugal",
  },
  {
    key: "Évora",
    text: "Évora",
    country: "Portugal",
  },
  {
    key: "Faro",
    text: "Faro",
    country: "Portugal",
  },
  {
    key: "Guarda",
    text: "Guarda",
    country: "Portugal",
  },
  {
    key: "Leiria",
    text: "Leiria",
    country: "Portugal",
  },
  {
    key: "Lisbon",
    text: "Lisbon",
    country: "Portugal",
  },
  {
    key: "Portalegre",
    text: "Portalegre",
    country: "Portugal",
  },
  {
    key: "Porto",
    text: "Porto",
    country: "Portugal",
  },
  {
    key: "Santarém",
    text: "Santarém",
    country: "Portugal",
  },
  {
    key: "Setúbal",
    text: "Setúbal",
    country: "Portugal",
  },
  {
    key: "Viana do Castelo",
    text: "Viana do Castelo",
    country: "Portugal",
  },
  {
    key: "Vila Real",
    text: "Vila Real",
    country: "Portugal",
  },
  {
    key: "Viseu",
    text: "Viseu",
    country: "Portugal",
  },
  {
    key: "Azores",
    text: "Azores",
    country: "Portugal",
  },
  {
    key: "Madeira",
    text: "Madeira",
    country: "Portugal",
  },
];

const swedenStates = [
  {
    key: "Blekinge",
    text: "Blekinge",
    country: "Sweden",
  },
  {
    key: "Dalarna",
    text: "Dalarna",
    country: "Sweden",
  },
  {
    key: "Gotland",
    text: "Gotland",
    country: "Sweden",
  },
  {
    key: "Gävleborg",
    text: "Gävleborg",
    country: "Sweden",
  },
  {
    key: "Halland",
    text: "Halland",
    country: "Sweden",
  },
  {
    key: "Jämtland",
    text: "Jämtland",
    country: "Sweden",
  },
  {
    key: "Jönköping",
    text: "Jönköping",
    country: "Sweden",
  },
  {
    key: "Kalmar",
    text: "Kalmar",
    country: "Sweden",
  },
  {
    key: "Kronoberg",
    text: "Kronoberg",
    country: "Sweden",
  },
  {
    key: "Norrbotten",
    text: "Norrbotten",
    country: "Sweden",
  },
  {
    key: "Örebro",
    text: "Örebro",
    country: "Sweden",
  },
  {
    key: "Östergötland",
    text: "Östergötland",
    country: "Sweden",
  },
  {
    key: "Skåne",
    text: "Skåne",
    country: "Sweden",
  },
  {
    key: "Södermanland",
    text: "Södermanland",
    country: "Sweden",
  },
  {
    key: "Stockholm",
    text: "Stockholm",
    country: "Sweden",
  },
  {
    key: "Uppsala",
    text: "Uppsala",
    country: "Sweden",
  },
  {
    key: "Värmland",
    text: "Värmland",
    country: "Sweden",
  },
  {
    key: "Västerbotten",
    text: "Västerbotten",
    country: "Sweden",
  },
  {
    key: "Västernorrland",
    text: "Västernorrland",
    country: "Sweden",
  },
  {
    key: "Västmanland",
    text: "Västmanland",
    country: "Sweden",
  },
  {
    key: "Västra Götaland",
    text: "Västra Götaland",
    country: "Sweden",
  },
];

const switzerlandStates = [
  {
    key: "Aargau",
    text: "Aargau",
    country: "Switzerland",
  },
  {
    key: "Appenzell Ausserrhoden",
    text: "Appenzell Ausserrhoden",
    country: "Switzerland",
  },
  {
    key: "Appenzell Innerrhoden",
    text: "Appenzell Innerrhoden",
    country: "Switzerland",
  },
  {
    key: "Basel-Landschaft",
    text: "Basel-Landschaft",
    country: "Switzerland",
  },
  {
    key: "Basel-Stadt",
    text: "Basel-Stadt",
    country: "Switzerland",
  },
  {
    key: "Bern",
    text: "Bern",
    country: "Switzerland",
  },
  {
    key: "Fribourg",
    text: "Fribourg",
    country: "Switzerland",
  },
  {
    key: "Geneva",
    text: "Geneva",
    country: "Switzerland",
  },
  {
    key: "Glarus",
    text: "Glarus",
    country: "Switzerland",
  },
  {
    key: "Graubünden",
    text: "Graubünden",
    country: "Switzerland",
  },
  {
    key: "Jura",
    text: "Jura",
    country: "Switzerland",
  },
  {
    key: "Lucerne",
    text: "Lucerne",
    country: "Switzerland",
  },
  {
    key: "Neuchâtel",
    text: "Neuchâtel",
    country: "Switzerland",
  },
  {
    key: "Nidwalden",
    text: "Nidwalden",
    country: "Switzerland",
  },
  {
    key: "Obwalden",
    text: "Obwalden",
    country: "Switzerland",
  },
  {
    key: "Schaffhausen",
    text: "Schaffhausen",
    country: "Switzerland",
  },
  {
    key: "Schwyz",
    text: "Schwyz",
    country: "Switzerland",
  },
  {
    key: "Solothurn",
    text: "Solothurn",
    country: "Switzerland",
  },
  {
    key: "St. Gallen",
    text: "St. Gallen",
    country: "Switzerland",
  },
  {
    key: "Thurgau",
    text: "Thurgau",
    country: "Switzerland",
  },
  {
    key: "Ticino",
    text: "Ticino",
    country: "Switzerland",
  },
  {
    key: "Uri",
    text: "Uri",
    country: "Switzerland",
  },
  {
    key: "Valais",
    text: "Valais",
    country: "Switzerland",
  },
  {
    key: "Vaud",
    text: "Vaud",
    country: "Switzerland",
  },
  {
    key: "Zug",
    text: "Zug",
    country: "Switzerland",
  },
  {
    key: "Zurich",
    text: "Zurich",
    country: "Switzerland",
  },
];

export const countryWiseStateList = [
  ...chinaStates,
  ...singaporeStates,
  ...japanStates,
  ...germanyStates,
  ...franceStates,
  ...spainStates,
  ...italyStates,
  ...austriaStates,
  ...belgiumStates,
  ...finlandStates,
  ...denmarkStates,
  ...irelandStates,
  ...luxembourgStates,
  ...netherlandStates,
  ...newZealandStates,
  ...norwayStates,
  ...portugalStates,
  ...swedenStates,
  ...switzerlandStates,
];